import React, {Fragment, useEffect, useState} from 'react'
import {TextField} from 'formik-material-ui'
import {useLocation} from 'react-router-dom'
import {Grid, Grow, Typography} from '@material-ui/core'
import {Field, useFormikContext} from 'formik'

import SponsorMissingImage from '../../../../assets/astronaut.png'
import CustomDialog from '../../../../components/CustomDialog'
import MaskField from '../../../../components/MaskField'
import {StepHeader} from '../styles'

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Step1 = () => {
  let query = useQuery();
  const sponsorParam = query.get("sponsor")
  const [sponsorMissingOpen, setSponsorMissingOpen] = useState(false)
  const {setFieldValue, setFieldTouched, values} = useFormikContext()
  const {sponsor} = values
  useEffect(() => {
    if (!sponsorParam) {
      setSponsorMissingOpen(true)
      setFieldValue('sponsor', undefined)
    } else {
      setFieldTouched('sponsor', true)
      setFieldValue('sponsor', sponsorParam)
    }
  }, [setFieldTouched, setFieldValue, sponsorParam])
  return (
    <Fragment>
      <CustomDialog
        open={sponsorMissingOpen}
        onClose={() => setSponsorMissingOpen(false)}
        title="Qual o Patrocinador?"
        description="Patrocinador não encontrado no endereço de indicação, por favor digite-o no campo abaixo."
        image={SponsorMissingImage}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              fullWidth
              name="sponsor"
              type="text"
              component={TextField}
              label="Digite o patrocinador"
            />
          </Grid>
        </Grid>
      </CustomDialog>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            component="h5"
            variant="h5"
            gutterBottom
            color="textPrimary">
            Conta Parceiro Sistema Paralelo
          </Typography>
          <Typography
            component="p"
            variant="body1"
            gutterBottom
            color="textPrimary">
            Uma conta digital para nossos parceiros, sem burocracia nem papelada.
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              fullWidth
              name="cnpj"
              type="tel"
              mask="99.999.999/9999-99"
              component={MaskField}
              label="Digite o seu CNPJ"
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              fullWidth
              name="email"
              type="email-address"
              component={TextField}
              label="Digite o seu e-mail"
              helperText="Use o seu melhor e-mail"
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              fullWidth
              name="username"
              type="text"
              component={TextField}
              label="Nome de usuário"
              helperText="Utilize apenas letras e números sem espaços"
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              disabled={sponsorParam}
              value={sponsor}
              fullWidth
              name="sponsor"
              type="text"
              component={TextField}
              label="Patrocinador"
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  );
};

export default Step1;
